import { alert } from '@/shared/ui/dialog'

import { getErrorMessage } from './parse'
import type { AppError, ErrorKeyNames } from './types'

function stripHtml(html: string): string {
  return html
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export const showErrorAlert = (
  error: AppError,
  errorMessagesTrans: ErrorKeyNames = {}
): void => {
  const { title, message } = getErrorMessage(error, errorMessagesTrans)

  void alert({
    variant: 'destructive',
    title,
    description: stripHtml(message)
  })
}
